import { useQuery, useMutation, useQueryClient } from "@tanstack/react-query";
import * as flexibleDiscountApi from "../../../api/flexibleDiscount";

export function useFlexibleDiscounts() {
  return useQuery({
    queryKey: ["flexibleDiscounts"],
    queryFn: () => flexibleDiscountApi.fetchAll(),
  });
}

export function useSaveFlexibleDiscount() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (req) => flexibleDiscountApi.saveOrUpdate(null, req),
    onSuccess: () => qc.invalidateQueries({ queryKey: ["flexibleDiscounts"] }),
  });
}

export function useArchiveFlexibleDiscount() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (id) => flexibleDiscountApi.archive(null, id),
    onSuccess: () => qc.invalidateQueries({ queryKey: ["flexibleDiscounts"] }),
  });
}
